import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import { TextBox } from "devextreme-react";

const GlobalFiter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 1000);

  return (
    <div style={{ maxWidth: "420px", width: "100%" }}>
      {/* <input
    type="text"
    className="form-control"
    placeholder="Search"
  ></input> */}
      <TextBox
        placeholder="Search"
        valueChangeEvent="keyup"
        showClearButton={true}
        onValueChanged={(e) => {
          setValue(e.value);
          onChange(e.value);
        }}
        value={value || ""}
      />
    </div>
  );
};

export default GlobalFiter;
